import { Divider, Link, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { PGA_COM_HOST } from 'env'

const useStyles = makeStyles(theme => ({
  footerLinks: {
    position: 'relative',
    marginTop: 'auto',
    display: 'flex',
    padding: '1.5rem 3rem',
    borderTop: '1px solid #E0E0E0',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column-reverse',
    },
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      alignItems: 'center',
    },
  },
  links: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      columnGap: '3rem',
    },
    [theme.breakpoints.up('md')]: {
      alignItems: 'center',
      flexDirection: 'row',
      marginLeft: '5rem',
      alignSelf: 'flex-end',
    },
  },
  link: {
    [theme.breakpoints.down('sm')]: {
      padding: '6px 0px',
    },
  },
  copyright: {
    [theme.breakpoints.down('sm')]: {
      paddingTop: '18px',
    },
  },
}))

const Footer = () => {
  const classes = useStyles()
  const currentYear = new Date().getFullYear()

  return (
    <>
      <div className={classes.footerLinks}>
        <div className={classes.copyright}>
          <Typography variant="caption">
            {'\u00A9'} Copyright PGA of America {currentYear}.
          </Typography>
        </div>
        <div className={classes.links}>
          <Typography variant="caption" className={classes.link}>
            <Link
              href={`${PGA_COM_HOST}/pga-of-america/privacy-policy`}
              target="_blank"
              color="inherit"
            >
              Privacy Policy
            </Link>
          </Typography>
          <Divider orientation="vertical" flexItem variant="middle" />
          <Typography variant="caption" className={classes.link}>
            <Link
              href={`${PGA_COM_HOST}/platform-user-policies`}
              target="_blank"
              color="inherit"
            >
              Platform Policies
            </Link>
          </Typography>
          <Divider orientation="vertical" flexItem variant="middle" />
          <Typography variant="caption" className={classes.link}>
            <Link
              href={`${PGA_COM_HOST}/pga-of-america/terms-of-service`}
              target="_blank"
              color="inherit"
            >
              Terms of Service
            </Link>
          </Typography>
        </div>
      </div>
    </>
  )
}

export default Footer
